module.exports = __webpack_public_path__ + "static/media/pressure.4321b7c1.jpg";